export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return iso;
  }
}

export const cardCls = "bg-[#0F0F0F] border border-neutral-800 rounded-2xl";
export const thCls = "px-4 py-3 font-medium";
export const tdCls = "px-4 py-3 align-top";
